export default {
    change_request: $localize `Change request`,
    contact_from_customer: $localize `Contact from customer`,
    new_order: $localize `New order`,
    customer_cancelled: $localize `Customer cancelled`,
    employee_cancelled: $localize `Employee cancelled`,
    new_applicant: $localize `New applicant`,
    new_customer: $localize `New customer personnel`,
    payment_failed: $localize `Payment failed`,
    payment_successful: $localize `Payment successful`
}